module.exports = __webpack_public_path__ + "img/temples.3ff07dba.png";